export default __webpack_public_path__ + "static/media/Twitter-gray.57c0539e.svg";